import { createIconSetFromFontello } from 'react-native-vector-icons';

import navIconConfig from './nav-icon-config.json';

export const NavIcon = createIconSetFromFontello(navIconConfig);
